import { VERBS, XAPI_STATEMENT_TEMPLATES, getContentCategoryFromPath } from '../utils'

/**
 * @typedef {object} PlayStatementPayload
 * @property {object} content - The content the user is interacting with.
 * @property {string} playDuration - The number of seconds the user watched the video/listen to an audio.
 * @property {object} tenant - The tenant.
 * @property {string} mediaType - The media type.
 */
/**
 * Create Prime statement.
 * @param {PlayStatementPayload} payload
 */
const createPrimeStatement = (payload) => {
  const statement = buildStatement(payload)
  const { content } = payload

  if (
    content?.legacyContent?.source === 'prime' &&
    content?.legacyContent?.id
  ) {
    statement.activity.extensions.pageId = content.legacyContent.id
  }

  return statement
}

/**
 * Create Helix statement.
 * @param {PlayStatementPayload} payload
 */
const createHelixStatement = (payload) => {
  const statement = buildStatement(payload)
  const { content } = payload

  if (
    content?.legacyContent?.source === 'helix' &&
    content?.legacyContent?.id
  ) {
    statement.activity.extensions.pageId = content.legacyContent.id
  }

  return statement
}

/**
 * Create an XAPI event payload.
 * @param {PlayStatementPayload} payload - XAPI payload.
 */
const buildStatement = ({
  content,
  tenant,
  mediaType,
  playDuration
}) => {
  const { topicName, subjectName } = getContentCategoryFromPath(
    content.categoryPath
  )
  const [pageType] = content.primaryType

  return {
    verb: VERBS.WATCH,
    result: {
      extensions: {
        mediaType,
        playDuration
      }
    },
    activity: {
      extensions: {
        pageId: content.locationId,
        pageType,
        skillArea: subjectName,
        subSkillArea: topicName
      }
    }
  }
}

/**
 * Create an XAPI event payload.
 * @param {PlayStatementPayload} payload - XAPI payload.
 * @returns {object}
 */
const create = (payload) => {
  const template =
    payload?.tenant?.features?.xapi?.statementTemplate ||
    XAPI_STATEMENT_TEMPLATES.MT3

  if (template === XAPI_STATEMENT_TEMPLATES.PRIME) {
    return createPrimeStatement(payload)
  }

  if (template === XAPI_STATEMENT_TEMPLATES.HELIX) {
    return createHelixStatement(payload)
  }

  return buildStatement(payload)
}

export default {
  create
}
